var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoffee = function SvgCoffee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 1.875V4.375",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 1.875V4.375",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 1.875V4.375",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 16.875H16.25",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50781 16.875C5.31162 16.3261 4.29811 15.4454 3.58767 14.3375C2.87723 13.2296 2.49973 11.9411 2.5 10.625V6.875H16.25V10.625C16.2503 11.9411 15.8728 13.2296 15.1623 14.3375C14.4519 15.4454 13.4384 16.3261 12.2422 16.875",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2499 6.875C16.9129 6.875 17.5488 7.13839 18.0177 7.60723C18.4865 8.07607 18.7499 8.71196 18.7499 9.375V10C18.7499 10.663 18.4865 11.2989 18.0177 11.7678C17.5488 12.2366 16.9129 12.5 16.2499 12.5H15.9858",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCoffee;